import { Link, useNavigate, useSearchParams } from 'react-router';
import { Card, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FixedHeader } from '@/components/fixed-header';
import welcomeMockup from '@/assets/welcome-mockup.png';
import { useI18nContext } from '@/i18n/i18n-react';

export default function CongratulationsPage() {
  const navigate = useNavigate();
  const { LL } = useI18nContext();

  const [search] = useSearchParams();
  const params = new URLSearchParams(search);

  return (
    <div className="container mx-auto flex items-center justify-center min-h-screen p-4 py-[150px]">
      <FixedHeader />

      <Card className="w-full max-w-md border-none">
        <CardContent className="space-y-8">
          <div className="flex justify-center">
            <img src={welcomeMockup} className="max-h-[40vh]" />
          </div>
          <CardTitle className="text-center">
            {LL.congratulations.title()}
          </CardTitle>
          <p className="text-muted-foreground text-lg text-center">
            {LL.congratulations.description()}
          </p>
          <Link
            to={
              params.get('tcrs') ? `/signup/${params.get('tcrs')}` : `/signup`
            }
          >
            <Button
              onClick={() => navigate('/signup')}
              className="w-full mt-6 text-lg"
              size="lg"
            >
              {LL.congratulations.configureAppButton()}
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
